module.exports = __webpack_public_path__ + "bdd0a718fb26897dd889a080aac4bd5a.png";